import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '@steelbuy/modal-dialog';
import { ConfirmCancelModel } from '@steelbuy/ui-primitive';

export const UnsavedRFQItemModal = ({
    show,
    onModalClose,
    onConfirm,
}: {
    show: boolean;
    onModalClose: () => void;
    onConfirm: () => void;
}) => {
    const { t } = useTranslation(['translation', 'uiDomain']);
    const unsavedItemModal = useModal(onModalClose);

    useEffect(() => {
        if (show) {
            unsavedItemModal.show();
        } else {
            unsavedItemModal.hide();
        }
    }, [show]);

    return (
        <ConfirmCancelModel
            modalAccessor={unsavedItemModal}
            header={t('translation:application.createRFQ.unsavedItemModal.headline')}
            cancelLabel={t('uiDomain:common.cancel')}
            submitLabel={t('translation:application.createRFQ.unsavedItemModal.continueLabel')}
            onSubmit={onConfirm}
            onClose={onModalClose}
            isSubmitting={false}
        />
    );
};
